module.exports = __webpack_public_path__ + "img/arts-title.a083f08b.png";